import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import state from './initialState';

const BoardStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default BoardStore;
